// Created by Nhat Do 6/4/2020
/*
 * Use in all system expect Forum
 * */

import urls from './urls';
import axios from 'axios';
import { addParamsToQueryString } from '../functions/utils';
import { IApiResponse } from '../interfaces/IApiResponse';

interface Params {
  listCommentId?: string;
  size?: number;
  commentParentID?: string;
  cmdId?: string;
  [key: string]: any;
}

class commentsSystemApi {
  static getCommentReplies(params: Params): Promise<IApiResponse<any>> {
    const string = params
      ? {
          id: params.listCommentId,
          size: params.size || 3,
        }
      : null;
    const url = addParamsToQueryString(urls.GET_COMMENTS_REPLIES, string);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getCommentRepliesFull(params: Params): Promise<IApiResponse<any>> {
    let _params = {size:params.pageSize || params.size , page:params.page}
    const url = addParamsToQueryString(urls.GET_COMMENTS_REPLY_FULL.replace('{CommentParentID}', params.commentParentID || ''), _params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateCommentLike(params: Params): Promise<IApiResponse<any>> {
    const url = urls.POST_CREATE_COMMENT_LIKE.replace('{ID}', params.cmdId || '');
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteCommentLike(params: Params): Promise<IApiResponse<any>> {
    const url = urls.PATCH_COMMENT_LIKE.replace('{ID}', params.cmdId || '');
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteComment(commentId: number): Promise<IApiResponse<any>> {
    const url = urls.DELETE_COMMENT.replace('{ID}', commentId.toString());
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getCommentLikes(commentId: string, page: number = 1, size: number = 12): Promise<IApiResponse<any>> {
    const string = {
      page: page || 1,
      size: size || 12,
    };
    const url = addParamsToQueryString(urls.GET_COMMENTS_LIKE.replace('{ID}', commentId), string);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default commentsSystemApi;
